import { useMutation, useQueryClient } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { useNavigate } from "react-router-dom";
import { UserAuthenticationEndPoint } from "../../api-routes";
import useGlobalContext from "../../contexts-hooks/hooks/useGlobalContext";
const login = async (data) => {
  return (await axiosInstance.post(UserAuthenticationEndPoint.LOGIN, data))
    .data;
};
const signUp = async (data) => {
  return (
    await axiosInstance.post(UserAuthenticationEndPoint.CREATE_USER, data)
  ).data;
};
const authenticate = async (data) => {
  return (await axiosInstance.get(UserAuthenticationEndPoint.AUTHENTICATE))
    .data;
};
const logOut = async (data) => {
  return (await axiosInstance.get(UserAuthenticationEndPoint.LOGOUT)).data;
};

export const useLogin = () => {
  const navigation = useNavigate();
  const { dispatch } = useGlobalContext();
  return useMutation({
    mutationFn: (data) => login(data),
    onSuccess(data) {
      sessionStorage.removeItem("global_talent_search_state");
      sessionStorage.clear();
      localStorage.setItem("roleType", data.data.user.role);
      if (data.token) {
        localStorage.setItem("token", data.token);
      }
      dispatch({ type: "SET_USER", payload: data.data.user });
      dispatch({ type: "SET_IS_AUTHENTICATED", payload: false });
      navigation("/app/global-talent-search");
    },
  });
};

export const useSignUp = () => {
  const navigation = useNavigate();
  return useMutation({
    mutationFn: (data) => signUp(data),
    onSuccess: (data) => {
      if (data.token) {
        localStorage.setItem("token", data.token);
      }
    },
  });
};

export const useCreateRecruiter = () => {
  return useMutation({
    mutationFn: (data) => signUp(data),
  });
};

export const useAuthenticate = () => {
  const { dispatch } = useGlobalContext();
  const navigation = useNavigate();

  return useMutation({
    mutationFn: (data) => authenticate(data),
  });
};

export const useLogOut = () => {
  const navigation = useNavigate();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => logOut(data),
    onSuccess: (data) => {
      sessionStorage.removeItem("global_talent_search_state");
      sessionStorage.clear();
      localStorage.removeItem("token");
      localStorage.removeItem("roleType");
      queryClient.clear();
      navigation("/");
    },
    onError: () => {
      sessionStorage.removeItem("global_talent_search_state");
      sessionStorage.clear();
      localStorage.removeItem("token");
      localStorage.removeItem("roleType");
      queryClient.clear();
      navigation("/");
    },
  });
};

